// extracted by mini-css-extract-plugin
export var gif = "_d9-0";